var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalUnits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999808 11.0004H1.99983V18.0006C1.99983 19.1036 2.89685 20.0006 3.99987 20.0006H16.0001C17.1032 20.0006 18.0002 19.1036 18.0002 18.0006V11.0004H19.0002C19.1979 11.0004 19.3912 10.9417 19.5557 10.8318C19.7201 10.7219 19.8482 10.5658 19.9239 10.3831C19.9996 10.2004 20.0194 9.99934 19.9808 9.80538C19.9422 9.61142 19.847 9.43325 19.7072 9.2934L10.707 0.293207C10.6142 0.20026 10.504 0.12652 10.3827 0.0762084C10.2614 0.0258966 10.1313 0 10 0C9.86866 0 9.73862 0.0258966 9.6173 0.0762084C9.49598 0.12652 9.38578 0.20026 9.29299 0.293207L0.292793 9.2934C0.152981 9.43325 0.0577723 9.61142 0.0192039 9.80538C-0.0193645 9.99934 0.00043896 10.2004 0.0761106 10.3831C0.151782 10.5658 0.279924 10.7219 0.444338 10.8318C0.608751 10.9417 0.802054 11.0004 0.999808 11.0004ZM7.99996 18.0006V13.0005H12V18.0006H7.99996ZM10 2.41425L16.0001 8.41438V13.0005L16.0011 18.0006H14.0001V13.0005C14.0001 11.8975 13.1031 11.0004 12 11.0004H7.99996C6.89693 11.0004 5.99991 11.8975 5.99991 13.0005V18.0006H3.99987V8.41438L10 2.41425Z",
    fill: "#5981E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUnits);
export default __webpack_public_path__ + "static/media/total_units.174986d3378a2aac09fe8e0e52a9892a.svg";
export { ForwardRef as ReactComponent };